import { render, staticRenderFns } from "./TableCustom.vue?vue&type=template&id=45e08895&scoped=true&"
import script from "./TableCustom.vue?vue&type=script&lang=js&"
export * from "./TableCustom.vue?vue&type=script&lang=js&"
import style0 from "./TableCustom.vue?vue&type=style&index=0&id=45e08895&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e08895",
  null
  
)

export default component.exports